import {
  ArrowRight,
  FolderTree,
  Tags,
  Image,
  FileText,
  Sparkles,
  Tag,
  CheckCircle,
  Search,
  Eye,
  ShoppingCart,
} from "lucide-react";

const getPriorities = ({
  titleQuality,
  descriptionQuality,
  imageQuality,
  seoQuality,
  altTagsQuality,
  categoryQuality,
  t
}: {
  titleQuality: number;
  descriptionQuality: number;
  imageQuality: number;
  seoQuality: number;
  altTagsQuality: number;
  categoryQuality: number;
  t: any;
}) => {
  const scores = [
    {
      type: "titles",
      score: titleQuality,
      threshold: 60,
      isQuickWin: true,
      icon: FileText,
      metricTitle: t('dashboard.titles'),
      messages: {
        achievement: t('priorities.titles_achievement'),
        quickWin: t('priorities.titles_quick_win'),
        opportunity: t('priorities.titles_opportunity'),
      },
    },
    {
      type: "descriptions",
      score: descriptionQuality,
      threshold: 75,
      isQuickWin: true,
      icon: FileText,
      metricTitle: t('dashboard.descriptions'),
      messages: {
        achievement: t('priorities.descriptions_achievement'),
        quickWin: t('priorities.descriptions_quick_win'),
        opportunity: t('priorities.descriptions_opportunity'),
      },
    },
    {
      type: "images",
      score: imageQuality,
      threshold: 70,
      isQuickWin: false,
      icon: Image,
      metricTitle: t('dashboard.images'),
      messages: {
        achievement: t('priorities.images_achievement'),
        quickWin: t('priorities.images_quick_win'),
        opportunity: t('priorities.images_opportunity'),
      },
    },
    {
      type: "seo",
      score: seoQuality,
      threshold: 65,
      isQuickWin: true,
      icon: Search,
      metricTitle: t('dashboard.seo'),
      messages: {
        achievement: t('priorities.seo_achievement'),
        quickWin: t('priorities.seo_quick_win'),
        opportunity: t('priorities.seo_opportunity'),
      },
    },
    {
      type: "altTags",
      score: altTagsQuality,
      threshold: 50,
      isQuickWin: true,
      icon: Tag,
      metricTitle: t('dashboard.alt_texts'),
      messages: {
        achievement: t('priorities.alt_texts_achievement'),
        quickWin: t('priorities.alt_texts_quick_win'),
        opportunity: t('priorities.alt_texts_opportunity'),
      },
    },
    {
      type: "categories",
      score: categoryQuality,
      threshold: 60,
      isQuickWin: true,
      icon: FolderTree,
      metricTitle: t('dashboard.categories'),
      messages: {
        achievement: t('priorities.categories_achievement'),
        quickWin: t('priorities.categories_quick_win'),
        opportunity: t('priorities.categories_opportunity'),
      },
    },
  ];
  const processedScores = scores.map((item) => {
    const isAchievement = item.score >= 80;
    const isQuickWin = !isAchievement && item.isQuickWin;

    return {
      type: item.type,
      icon: item.icon,
      metricTitle: item.metricTitle,
      score: item.score,
      title: isAchievement
        ? t('priorities.great_achievement')
        : isQuickWin
          ? t('priorities.quick_win')
          : t('priorities.growth_opportunity'),
      message: isAchievement
        ? item.messages.achievement
        : isQuickWin
          ? item.messages.quickWin
          : item.messages.opportunity,
      color: isAchievement ? "emerald" : isQuickWin ? "blue" : "purple",
    };
  });

  // Sort and prioritize
  const achievements = processedScores.filter((item) => item.score >= 80);
  const quickWins = processedScores.filter(
    (item) => item.score < 80 && item.title === t('priorities.quick_win')
  );
  const opportunities = processedScores.filter(
    (item) => item.score < 80 && item.title === t('priorities.growth_opportunity')
  );

  // Create prioritized array
  let priorities = [
    ...achievements.slice(0, 1),
    ...quickWins.slice(0, 1),
    ...opportunities.slice(0, 1),
  ].filter(Boolean);

  // Fill remaining slots if needed
  while (priorities.length < 3) {
    if (
      quickWins.length >
      priorities.filter((p) => p.title === t('priorities.quick_win')).length
    ) {
      priorities.push(
        quickWins[priorities.filter((p) => p.title === t('priorities.quick_win')).length]
      );
    } else if (
      opportunities.length >
      priorities.filter((p) => p.title === t('priorities.growth_opportunity')).length
    ) {
      priorities.push(
        opportunities[
          priorities.filter((p) => p.title === t('priorities.growth_opportunity')).length
        ]
      );
    } else {
      break;
    }
  }

  return priorities.slice(0, 3);
};

export default getPriorities;